import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FilterStoreService } from '../../../../services/filter-store.service';
import { PageIndexService } from '../../../../services/page-index-service';
import { SubProjectControllerRequestService } from '../../../../services/api/sub-project-controller-request.service';
import { SubProjectImmoNew } from '../../../../model/project/sub-project-immo-new';
import { Lightbox } from 'ngx-lightbox';
import DateHelper from '../../../../helpers/date-helper';
import { Router } from '@angular/router';
import { AbstractImmoOverviewComponent } from '../abstract-immo-overview.component';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { SnackService } from '../../../../services/snack.service';
import { ModalService } from '../../../../services/modal.service';

@Component({
  selector: 'new-immo-overview',
  templateUrl: '../abstract-immo-overview.component.html',
  styleUrls: ['../abstract-immo-overview.component.scss'],
})
export class NewImmoOverviewComponent
  extends AbstractImmoOverviewComponent<SubProjectImmoNew>
  implements OnInit
{
  @Output()
  countChange = new EventEmitter<number>();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    protected filterStoreService: FilterStoreService,
    protected pageIndexService: PageIndexService,
    protected cd: ChangeDetectorRef,
    protected subProjectService: SubProjectControllerRequestService,
    protected _lightbox: Lightbox,
    protected router: Router,
    private snackService: SnackService,
    private modalService: ModalService
  ) {
    super(
      [
        {
          key: 'project__id',
          active: false,
          strictEquality: true,
          numeric: true,
        },
        {
          key: 'currentCreatedAt',
          active: false,
          strictEquality: true,
          numeric: false,
        },
        {
          key: 'immoNewCustomerName',
          active: false,
          strictEquality: false,
          numeric: false,
        },
        {
          key: 'projectPlacement__address',
          active: false,
          strictEquality: true,
          numeric: false,
        },
        {
          key: 'needSubProjectApproval',
          active: true,
          strictEquality: false,
          numeric: false,
        },
      ],
      filterStoreService,
      pageIndexService,
      cd,
      subProjectService,
      _lightbox,
      router
    );
  }

  ngOnInit() {
    super.ngOnInit();
    this.hasActionButtons = true;
  }

  public override openTour(subProject: SubProjectImmoNew): void {
    throw new Error('Method not implemented.');
  }
  public override copyProjectId(subProject: SubProjectImmoNew): void {
    throw new Error('Method not implemented.');
  }
  protected override getPaginator(): MatPaginator {
    return this.paginator;
  }

  protected override initDisplayedColumns(): void {
    this.displayedColumns = [
      'projectId',
      'request',
      'deadline',
      'requestor',
      'customerName',
      'address',
      'kind',
      'measurements',
      'type',
      'design',
      'photo',
      'displayStatus',
      'designFinished',
      'dropdownActions',
    ];
  }

  protected override initSortSettings(): void {
    this.sortColumn = 'currentCreatedAt';
    this.sortAscending = false;
  }

  protected override getLocalStorageKey(): string {
    return 'NewImmoOverviewComponent';
  }

  protected override fetchItems() {
    this.loading = true;
    this.items = [];

    this.subProjectService
      .getImmoNew(
        this.generateFilterString(),
        this.sortColumn,
        this.sortAscending,
        this.paginator.pageSize,
        this.paginator.pageIndex,
        false
      )
      .then((res) => {
        this.processPageResult(res);
        this.totalItems = res.totalItems;
        this.countChange.emit(this.totalItems);
        this.items = this.parsedItems(res.items);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private parsedItems(items: SubProjectImmoNew[]): SubProjectImmoNew[] {
    const result: SubProjectImmoNew[] = [];

    const onHoldItems: SubProjectImmoNew[] = [];
    items.forEach((item) => {
      this.setComponentHelperFields(item);
      if (item.onHold) {
        onHoldItems.push(item);
      } else {
        result.push(item);
      }
    });

    onHoldItems.forEach((e) => {
      result.push(e);
    });

    return result;
  }

  private setComponentHelperFields(item: SubProjectImmoNew): void {
    if (item.project.ipBoards != null && item.project.ipBoards.length > 0) {
      item.project.firstIpBoard = item.project.ipBoards[0];
    }

    if (item.onHold) {
      item.statusClass = 'on-hold';
    } else {
      //status should be 'Nieuw'
      if (item.approved) {
        item.statusClass = 'approved';
      } else if (item.project.collaborative === true) {
        item.statusClass = 'collab';
      } else {
        item.statusClass = 'new';
      }
    }

    if (item.currentCreatedAt != null) {
      item.currentCreatedAtDisplay = DateHelper.formatDate(
        item.currentCreatedAt
      );
    }
  }

  public openProject(subProject: SubProjectImmoNew): void {
    this.router.navigate([
      '/job',
      subProject.project == null ? null : subProject.project.id,
      subProject.id,
    ]);
  }

  public archive(subProject: SubProjectImmoNew): void {
    this.modalService.confirmDialog(
      'Verwijderen',
      'Weet u zeker dat u deze job wilt verwijderen?',
      (c) => {
        if (c) {
          this.subProjectService.archive(subProject.id).then(() => {
            this.snackService.showSuccess('Verwijdering succesvol');
            this.fetchItems();
          });
        }
      }
    );
  }
}
